import moment from 'moment';
import PropTypes from 'prop-types';
import { useState } from 'react';
import { Table } from '../../../../../common/components';
import { aRAgingTableColumns } from '../../../../../utils/constant';
import DownloadModal from '../../../downloadModal/downloadModal';
import EmailModal from '../../../emailModal/emailModal';
import ItemEmptyTile from '../../../item-empty-tile/item-empty-tile';
import Toolbar from '../../../toolbar/toolbar';
import ARAgingReportRow from './arAgingReportRow';

const ARAgingReport = ({ tableData, date }) => {
  const [isDownloadModalOpen, setIsDownloadModalOpen] = useState(false);
  const [isEmailModalOpen, setIsEmailModalOpen] = useState(false);

  const toggleEmailModal = () => {
    if (tableData?.length) {
      setIsEmailModalOpen(!isEmailModalOpen);
    }
  };

  const toggleDownloadModal = () => {
    if (tableData?.length) {
      setIsDownloadModalOpen(!isDownloadModalOpen);
    }
  };

  return (
    <>
      {tableData && tableData?.length > 0 ? (
        <>
          <Toolbar
            title="AR Aging - (AR Level)"
            subTitle={`As on Date: ${moment(date).format('MMM DD,YYYY')}`}
            optionOneLabel="Email Report"
            optionOneIcon="MdOutlineEmail"
            onOptionOneClick={toggleEmailModal}
            optionTwoLabel="Download Report"
            optionTwoIcon="FiDownload"
            onOptionTwoClick={toggleDownloadModal}
            isTableDataPresent={tableData?.length > 0}
          />
          <Table headers={aRAgingTableColumns} bordered responsive className="dashboard-table">
            <tbody>
              {tableData?.map((rowData, rowNumber) => (
                <ARAgingReportRow key={rowNumber} rowData={rowData} id={rowNumber} />
              ))}
            </tbody>
          </Table>
        </>
      ) : (
        <ItemEmptyTile />
      )}

      <EmailModal
        isOpen={isEmailModalOpen}
        toggle={toggleEmailModal}
        reportType="arAgingReport"
        apiValues={{ reportDate: date }}
        newFilters
      />
      <DownloadModal
        isOpen={isDownloadModalOpen}
        toggle={toggleDownloadModal}
        reportType="arAgingReport"
        urlParams={{ reportDate: date }}
        newFilters
      />
    </>
  );
};

ARAgingReport.propTypes = {
  tableData: PropTypes.shape([]).isRequired,
  date: PropTypes.string.isRequired,
};
export default ARAgingReport;
